import { requestGaAdmin } from './auth';

const COST_DASHBOARD_PATH = '/admin/cost/dashboard';

export async function getCostDashboard(accessToken) {
  const response = await requestGaAdmin(COST_DASHBOARD_PATH, { method: 'GET' }, accessToken);
  const text = await response.text();
  let body = null;
  try {
    body = text ? JSON.parse(text) : null;
  } catch {
    // Keep the response error below useful when an upstream returns HTML or an empty body.
  }
  if (!response.ok) {
    const error = new Error(body?.msg || body?.message || `Request failed (${response.status})`);
    error.status = response.status;
    error.code = body?.code;
    throw error;
  }
  return body?.data ?? body;
}
